import { Component, Inject, OnInit } from "@angular/core";
import { IABCMoneda, IParidadMoneda } from "../interfaces/IGetABCMonedas";
import { AbcMonedasService } from "../services/abc-monedas.service";
import { MAT_DIALOG_DATA, MatDialog } from "@angular/material/dialog";
import { Moneda } from "../../../portafolio/interfaces/moneda";
import { HelpersService } from "@shared/helpers/helpers.service";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { SwalService } from "@shared/utils/swal.service";
import Swal from "sweetalert2";

interface Column {
    field: string;
    header: string;
}
@Component({
    selector: "app-abc-monedas-paridades",
    templateUrl: "./abc-monedas-paridades.component.html",
    styleUrls: ["./abc-monedas-paridades.component.css"],
})
export class AbcMonedasParidadesComponent implements OnInit {
    dataSource: any[] = [];
    visibleModal: boolean = false;
    valueToSearch: string = "";
    dateToSearch: string = "";
    isEdit: boolean = false;

    columns: Column[] = [
        { field: "fecha", header: "Fecha" },
        { field: "factor", header: "Factor" },
        { field: "actions", header: "Acciones" },
    ];

    form: FormGroup;

    constructor(
        public _helpers: HelpersService,
        private monedasService: AbcMonedasService,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private dialog: MatDialog,
        private _swalService: SwalService,
        private fb: FormBuilder
    ) {
        this.form = this.fb.group({
            moneda: ["", Validators.required],
            fecha: ["", Validators.required],
            factor: [null, Validators.required],
        });

        this.initForm();
    }

    initForm(factor?: number, fecha?: any): void {
        let formattedFecha = this._helpers.DateNowInputString(); // Fecha actual por defecto

        if (fecha) {
            const [day, month, year] = fecha.split("/").map(Number); // Divide la fecha y convierte a números

            // Asegura que la fecha tenga siempre dos dígitos en día y mes
            const dayStr = day.toString().padStart(2, "0");
            const monthStr = month.toString().padStart(2, "0");

            formattedFecha = `${year}-${monthStr}-${dayStr}`; // Construye la fecha manualmente
        }

        this.form.patchValue({
            moneda: this.data.moneda,
            fecha: formattedFecha, // Ahora sí es compatible con <input type="date">
            factor: this.isEdit ? factor : null,
        });

        this.form.controls["moneda"].disable();
        this.form.controls["fecha"].disable();
    }

    ngOnInit() {
        this.getParidadXmoneda(this.data.moneda);
    }

    abrirModal(element?: IParidadMoneda) {
        this.isEdit = element ? true : false;
        this.visibleModal = true;
        this.isEdit ? this.initForm(element.factor, element.fecha) : this.initForm();
    }

    getParidadXmoneda(moneda: string) {
        this.monedasService.GetParidadXMoneda(moneda).subscribe({
            next: (res) => {
                this.dataSource = res.data;
            },
            error: (err) => {
                console.log(err);
            },
        });
    }

    preventTyping(event: KeyboardEvent): void {
        event.preventDefault();
    }

    getParidadXFecha(moneda: string) {
        let date = this._helpers.convertDateToDDMMYYYString(this.dateToSearch);
        this.monedasService.GetParidadXFecha(moneda, date).subscribe({
            next: (res) => {
                this.dataSource = [];
                this.dataSource.push(res.data);
            },
            error: (err) => {
                console.log(err);
            },
        });
    }

    deleteParidad(moneda: string, fecha: string) {
        Swal.fire({
            title: "Eliminar Paridad",
            text: "¿Estas seguro de eliminar la paridad?",
            icon: "warning",
            showCancelButton: true,
            iconColor: "#d33",
            confirmButtonColor: "#d33",
            confirmButtonText: "Sí, eliminar",
            cancelButtonText: "No",
        }).then((result) => {
            if (result.isConfirmed) {
                this.monedasService.DeleteParidad(moneda, fecha).subscribe({
                    next: (res) => {
                        this._swalService.success("Paridad Eliminada");
                        this.getParidadXmoneda(moneda);
                    },
                    error: (err) => {
                        console.log(err);
                        this._swalService.error("Error al eliminar paridad");
                    },
                });
            }
        });
    }

    closeParidades() {
        this.dialog.closeAll();
    }

    saveParidad() {
        this.form.controls["fecha"].setValue(this._helpers.convertDateToDDMMYYYString(this.form.controls["fecha"].value));
        if (!this.isEdit) {
            this.monedasService.CreateParidad(this.form.getRawValue()).subscribe({
                next: (res) => {
                    this._swalService.success("Paridad Guardada");
                    this.getParidadXmoneda(this.data.moneda);
                    this.visibleModal = false;
                    this.form.reset();
                },
                error: (err) => {
                    console.log(err);
                    this._swalService.error("Error al guardar paridad");
                    this.form.reset();
                    this.initForm();
                },
            });
        } else {
            this.monedasService.EditParidad(this.form.getRawValue()).subscribe({
                next: (res) => {
                    console.log(res);
                    this._swalService.success("Paridad Actualizada");
                    this.getParidadXmoneda(this.data.moneda);
                    this.visibleModal = false;
                    this.form.reset();
                },
                error: (err) => {
                    console.log(err);
                    this._swalService.error("Error al actualizar paridad");
                },
            });
        }
    }
}
